// src/components/Constant/InstructorHeadlineOptions.js

export const headlineOptions = [
  {
    category: "Technical",
    options: [
      "Full-Stack Developer | React & Node.js Expert",
      "Frontend Engineer | HTML, CSS, JavaScript",
      "Backend Developer | Java & Spring Boot Specialist",
      "Python Developer | Django & Flask Mentor",
      "DevOps Engineer | AWS & Docker Certified",
      "Machine Learning Engineer | AI & Deep Learning",
      "Data Scientist | Python, Pandas & Scikit-Learn",
      "Cloud Architect | Azure & Google Cloud Expert",
      "Cybersecurity Trainer | Ethical Hacking & Network Security",
    ],
  },
  {
    category: "Business & Marketing",
    options: [
      "Digital Marketing Strategist | SEO, Google Ads",
      "Social Media Coach | Instagram & LinkedIn Growth",
      "Business Analyst | Excel, Power BI & Tableau",
      "Startup Mentor | MVP to Product-Market Fit",
      "Entrepreneurship Coach | Business Model & Pitching",
      "Financial Analyst | Stock Market & Excel Modeling",
      "E-commerce Specialist | Shopify & Amazon FBA",
    ],
  },
  {
    category: "Creative & Design",
    options: [
      "UI/UX Designer | Figma & Adobe XD Specialist",
      "Graphic Designer | Photoshop & Illustrator Pro",
      "Video Editor | Premiere Pro & After Effects Expert",
      "3D Artist | Blender & Maya Instructor",
      "Photographer | DSLR, Editing & Portfolio Building",
      "Animator | 2D & Motion Graphics Expert",
    ],
  },
  {
    category: "Academic & Language",
    options: [
      "Mathematics Educator | Competitive Exams Coach",
      "Physics Teacher | Concept-Based Learning",
      "English Trainer | IELTS & TOEFL Specialist",
      "Spoken English Coach | Fluency & Grammar Focus",
      "Language Instructor | Spanish, French, German",
      "Coding for Kids | Scratch & Blockly Enthusiast",
    ],
  },
  {
    category: "Soft Skills & Personal Development",
    options: [
      "Public Speaking Coach | Confidence & Delivery",
      "Career Coach | Resume, Interview & LinkedIn",
      "Life Coach | Mindset & Goal Setting Mentor",
      "Time Management Expert | Productivity Tools",
      "Personal Branding Mentor | Build Online Presence",
      "Emotional Intelligence Trainer | Self-Awareness & Empathy",
    ],
  },
  {
    category: "Miscellaneous",
    options: [
      "Yoga Instructor | Mindfulness & Meditation Guide",
      "Fitness Trainer | Strength & Conditioning",
      "Cooking Expert | Indian & International Cuisine",
      "Music Instructor | Guitar, Piano & Theory",
      "Art Instructor | Drawing, Painting & Creativity",
    ],
  },
];
